import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { GeoCodingService } from 'src/app/services/geo-coding.service';
import { GeolocationService } from 'src/app/services/geolocation.service';
import { LoaderService } from 'src/app/services/loader.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-directions',
  templateUrl: './directions.component.html',
  styleUrls: ['./directions.component.scss']
})
export class DirectionsComponent implements OnInit {
  dataProfile: any = null

  registerForm: any;
  minDate?: Date;
  maxDate?: Date;

  dataLocalities: Observable<any[]> = of([])
  dataMunicipality: any
  dataState: any
  dataAddresses: any[] = []

  constructor(private loaderService: LoaderService, private coreService: CoreService, public dialog: MatDialog, public cookies: CookieService, public apiServices: ApiService, public router: Router, public apiUsersServices: UsersService, public formBuilder: FormBuilder) {

  }

  ngOnInit(): void {
    this.getDataAddresses()
  }

  getDataAddresses() {
    this.loaderService.show()
    this.apiUsersServices.getAddress().subscribe({
      next: (value) => {
        if (value.status) {
          this.dataAddresses = value.data
        }
        else {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
        }
        this.loaderService.hide()
      },
      error: (err) => {
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
        console.error(err)
        this.loaderService.hide()
      },
    })
  }

  searchDataZipCode() {
    let theZipCode = this.registerForm.value['main_zip_code']
    if (theZipCode.length == 5) {
      this.loaderService.show()
      this.apiUsersServices.getLocalitiesByZipCode(theZipCode).subscribe({
        next: (value) => {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: value.message } });
          if (value.status) {
            this.dataLocalities = of(value.data)
            if (this.dataProfile != null) {
              this.registerForm.get('locality_id')?.setValue(this.dataProfile.locality_id)
              this.onSelectionLocality({ value: this.dataProfile.locality_id + "" })
            }
          }
          this.loaderService.hide()
        },
        error: (err) => {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
          // console.log(err)
          this.loaderService.hide()
        }
      })
    }
  }

  onSelectionLocality(event: any) {
    let theLocality: any
    this.dataLocalities.forEach((localities: any) => {
      theLocality = localities.find((locality: any) => locality.id === parseInt(event.value))
      if (theLocality != undefined) {
        this.registerForm.get('municipality_id').setValue(theLocality.municipality.id)
        this.registerForm.get('state_id').setValue(theLocality.state.id)
        this.registerForm.get('municipality').setValue(theLocality.municipality.name)
        this.registerForm.get('state').setValue(theLocality.state.name)
      }
    })
  }

  addAddress() {
    const isMobile = window.innerWidth <= 768;

    const dialogRef = this.dialog.open(DialogAddAddress, {
      width: isMobile ? '94vw' : '780px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: 'calc(100vh - 30px)',
      backdropClass: 'nina-dialog-backdrop',
      data: { address: null }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getDataAddresses();
    });
  }

  editAddress(address: any) {
    const isMobile = window.innerWidth <= 768;

    const dialogRef = this.dialog.open(DialogAddAddress, {
      width: isMobile ? '94vw' : '780px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: 'calc(100vh - 30px)',
      backdropClass: 'nina-dialog-backdrop',
      data: { address: address }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getDataAddresses();
    });
  }

  deleteAddress(addressId: number) {
    this.loaderService.show()
    this.apiUsersServices.deleteAddress(addressId).subscribe({
      next: (value) => {
        if (value.status) {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Direccion eliminada correctamente" } });
          this.getDataAddresses()
        }
        this.loaderService.hide()
      },
      error: (err) => {
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
        console.error(err)
        this.loaderService.hide()
      }
    })
  }
}

@Component({
  selector: 'dialog-add-address',
  templateUrl: 'dialog-add-address.html',
  styleUrls: ['dialog-add-address.scss']
})

export class DialogAddAddress {
  prevData: any = null
  addressForm: any
  dataLocalities: Observable<any[]> = of([])
  dataMunicipality: any
  dataState: any
  map_lat: number = 25.537911020290082;
  map_lng: number = -103.41543316841125;
  zoom = 13
  latitude = 0
  longitude = 0
  direccionPin: string = '';
  constructor(private loaderService: LoaderService, public dialogRef: MatDialogRef<DialogAddAddress>, @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, public cookieService: CookieService, private coreService: CoreService, public apiUsersServices: UsersService, public formBuilder: FormBuilder, public geolocationService: GeolocationService, public geocodingService: GeoCodingService) {
    if (data.address != null) {
      this.prevData = data.address
      // console.log(this.prevData)
    }
    this.createForm()
  }

  ngOnInit(): void {

  }

  close(): void {
    this.dialogRef.close();
  }

  createForm() {
    this.addressForm = this.formBuilder.group({
      receiving_name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(64)]],
      state_id: ['', [Validators.required]],
      municipality_id: ['', [Validators.required]],
      locality_id: ['', [Validators.required]],
      zip_code: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      phone: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(/^\d+$/)]],
      street: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(128)]],
      references: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(128)]],
      ext_number: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(10)]],
      lat: ['', [Validators.required]],
      lng: ['', [Validators.required]],
      state: ['', []],
      municipality: ['', []],
    })

    if (this.prevData != null) {
      if (this.prevData.phone[0] == "5" && this.prevData.phone[1] == "2") {
        this.prevData.phone = this.prevData.phone.substring(2)
      }

      this.addressForm.get('receiving_name').setValue(this.prevData.receiving_name)
      this.addressForm.get('zip_code').setValue(this.prevData.zip_code)
      this.searchDataZipCode()
      this.addressForm.get('phone').setValue(this.prevData.phone)
      this.addressForm.get('street').setValue(this.prevData.street)
      this.addressForm.get('references').setValue(this.prevData.references)
      this.addressForm.get('ext_number').setValue(this.prevData.ext_number)
      this.addressForm.get('lat').setValue(this.prevData.lat)
      this.addressForm.get('lng').setValue(this.prevData.lng)

      if (this.prevData.lat != "0.0000000" && this.prevData.lng != "0.0000000") {
        this.latitude = parseFloat(this.prevData.lat)
        this.map_lat = parseFloat(this.prevData.lat)
        this.longitude = parseFloat(this.prevData.lng)
        this.map_lng = parseFloat(this.prevData.lng)
      }
    }
  }

  get receiving_name() { return this.addressForm.get('receiving_name'); }
  get state_id() { return this.addressForm.get('state_id'); }
  get municipality_id() { return this.addressForm.get('municipality_id'); }
  get locality_id() { return this.addressForm.get('locality_id'); }
  get zip_code() { return this.addressForm.get('zip_code'); }
  get phone() { return this.addressForm.get('phone'); }
  get street() { return this.addressForm.get('street'); }
  get references() { return this.addressForm.get('references'); }
  get ext_number() { return this.addressForm.get('ext_number'); }
  get lat() { return this.addressForm.get('lat'); }
  get lng() { return this.addressForm.get('lng'); }
  get state() { return this.addressForm.get('state'); }
  get municipality() { return this.addressForm.get('municipality'); }

  getErrorMessage(control: string): string {
    const controlErrors = this.addressForm.get(control)?.errors;
    if (controlErrors) {
      if (controlErrors.required) {
        return 'Este campo es requerido';
      } else if (controlErrors.minlength) {
        return `La longitud minima es: ${controlErrors.minlength.requiredLength}`;
      } else if (controlErrors.maxlength) {
        return `La longitud maxima es: ${controlErrors.maxlength.requiredLength}`;
      } else if (controlErrors.pattern) {
        return 'Formato invalido';
      }
    }
    return '';
  }

  searchDataZipCode() {
    let theZipCode = this.addressForm.value['zip_code']
    if (theZipCode.length == 5) {
      this.loaderService.show()
      this.apiUsersServices.getLocalitiesByZipCode(theZipCode).subscribe({
        next: (value) => {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: value.message } });
          if (value.status) {
            this.dataLocalities = of(value.data)
            if (this.prevData != null) {
              this.addressForm.get('locality_id')?.setValue(this.prevData.locality.id)
              this.onSelectionLocality({ value: this.prevData.locality.id + "" })
            }
          }
          this.loaderService.hide()
        },
        error: (err) => {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
          // console.log(err)
          this.loaderService.hide()
        }
      })
    }
  }

  addAddress() {
    let dataForm = { ...this.addressForm.value }
    dataForm.phone = "52" + dataForm.phone
    dataForm.lat = dataForm.lat + ""
    dataForm.lng = dataForm.lng + ""
    if (this.prevData == null) {
      this.loaderService.show()
      this.apiUsersServices.createAddress(dataForm).subscribe({
        next: (value) => {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: value.message } });
          if (value.status) {
            this.dialogRef.close()
          }
          this.loaderService.hide()
        },
        error: (err) => {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
          console.error(err)
          this.loaderService.hide()
        }
      })
    }
    else {
      this.loaderService.show()
      this.apiUsersServices.updateAddress(dataForm, this.prevData.id).subscribe({
        next: (value) => {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: value.message } });
          if (value.status) {
            this.dialogRef.close()
          }
          this.loaderService.hide()
        },
        error: (err) => {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
          console.error(err)
          this.loaderService.hide()
        }
      })
    }

  }

  onSelectionLocality(event: any) {
    let theLocality: any
    this.dataLocalities.forEach((localities: any) => {
      theLocality = localities.find((locality: any) => locality.id === parseInt(event.value))
      if (theLocality != undefined) {
        this.addressForm.get('municipality_id').setValue(theLocality.municipality.id)
        this.addressForm.get('state_id').setValue(theLocality.state.id)
        this.addressForm.get('municipality').setValue(theLocality.municipality.name)
        this.addressForm.get('state').setValue(theLocality.state.name)
      }
    })
  }

  onMapClickEvent(event: any) {
    this.latitude = event.coords.lat;
    this.longitude = event.coords.lng;
    this.addressForm.get('lat').setValue(this.latitude)
    this.addressForm.get('lng').setValue(this.longitude)

    // console.log('Coordenadas seleccionadas:', {
    //   lat: this.latitude,
    //   lng: this.longitude
    // });

    this.obtenerDireccionDesdeCoordenadas(
      this.latitude,
      this.longitude
    );
  }

  markerDragEnd(event: any) {
    this.latitude = event.coords.lat;
    this.longitude = event.coords.lng;
    this.addressForm.get('lat').setValue(this.latitude)
    this.addressForm.get('lng').setValue(this.longitude)

    // console.log('Pin movido:', {
    //   lat: this.latitude,
    //   lng: this.longitude
    // });

    this.obtenerDireccionDesdeCoordenadas(
      this.latitude,
      this.longitude
    );
  }

  obtenerDireccionDesdeCoordenadas(lat: number, lng: number) {
    this.geocodingService.getLocation(lat, lng).subscribe({
      next: (value) => {

        // if (!value || !value.results || value.results.length === 0) {
        //   console.log('No se encontró una dirección para estas coordenadas');
        //   return;
        // }

        const result = value.results[0];

        const componentes: any = {};

        result.address_components.forEach((component: any) => {

          component.types.forEach((type: string) => {
            componentes[type] = component.long_name;
          });

        });

        const direccion = {
          receiving_name: '',
          state_id: null,
          municipality_id: null,
          locality_id: null,

          zip_code:
            componentes.postal_code ?? '',

          phone: '',

          street:
            componentes.route ?? '',

          references: '',

          ext_number:
            componentes.street_number ?? '',

          lat: lat,

          lng: lng,

          state:
            componentes.administrative_area_level_1 ?? '',

          municipality:
            componentes.administrative_area_level_2 ?? '',

          locality:
            componentes.neighborhood ??
            componentes.sublocality ??
            componentes.sublocality_level_1 ??
            componentes.locality ??
            ''
        };

        const calle = componentes.route ?? '';
        const numero = componentes.street_number ?? '';
        const colonia =
          componentes.neighborhood ??
          componentes.sublocality ??
          componentes.sublocality_level_1 ??
          '';

        this.direccionPin = [
          calle,
          numero,
          colonia
        ].filter(Boolean).join(', ');

        // console.log('DIRECCIÓN FORMATEADA:', direccion);

        // console.log('RESPUESTA GOOGLE:', result);

      },

      error: (err) => {
        console.error('Error obteniendo dirección:', err);
      }
    });

  }
}
